import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import GoogleCertificateEpicClient from 'bundles/epic/clients/GoogleCertificate';

export const GOOGLE_REFRESH_CERTIFICATE_SLUGS = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-cybersecurity'
] as const;

export const shouldShowGoogleRefresh = (slug?: string) => {
  if (!slug) {
    return false;
  }

  return (
    GOOGLE_REFRESH_CERTIFICATE_SLUGS.includes(slug) &&
    (GrowthDiscoveryEpicClient.get('showGoogleRefreshCampaign') === true || GoogleCertificateEpicClient.get('showGoogleRefreshCampaign'))
  );
};

export default shouldShowGoogleRefresh;
